import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { actionCreators as jurisdictionActionCreators } from '../../store/JurisdictionStore';
import { actionCreators as sdmActionCreators } from '../../store/ScraperDefinitionModels';
import UIContext from '../../contexts/uiContext';
import ScraperByState from '../charts/ScraperByState';
import CircularProgress from '@material-ui/core/CircularProgress';
import progress from '../../styles/progress';
const MapUsaPage = props => {
    const progressClass = progress();
    const context = useContext(UIContext);

    if (context.pageTitle.indexOf('Map') === -1)
        context.setPageTitle(!window.elevation && 'Court & Arrest Coverage');

    let stateName = props.stateName || props.match.params.stateName;

    useEffect(() => {
        props.requestJurisdictions();
        props.requestSdms();
    }, []);

    if (props.sdms.all.length == 0 || props.jurisdictions.length == 0)
        return <CircularProgress className={progressClass.progress} />;

    return (
        <ScraperByState stateName={stateName} {...props} />
    );
};

export default connect(state => {
    return {
        jurisdictions: state.jurisdictions.all,
        ...state.scraperDefinitionModels,
        sdms: state.scraperDefinitionModels,
    };
},
    {
        ...jurisdictionActionCreators,
        requestSdms: sdmActionCreators.requestSdms,
    }
)(MapUsaPage);